import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { KeycloakTokenParsed } from 'keycloak-js';
import { keycloak } from '../auth/keykloak.config';

@Injectable({ providedIn: 'root' })
export class AuthService {
	isAuthenticated = signal<boolean>(false);
	private _userProfile = signal<KeycloakTokenParsed | null>(null);

	constructor(private _http: HttpClient) {
		this.syncState();
	}

	private syncState() {
		this.isAuthenticated.set(!!keycloak.token);
		this._userProfile.set(keycloak.tokenParsed ?? null);
	}

	get isLoggedIn(): boolean {
		return this.isAuthenticated();
	}

	get userProfile(): KeycloakTokenParsed | null {
		return this._userProfile();
	}

	login() {
		keycloak.login({
			redirectUri: window.location.origin
		});
	}

	logout() {
		keycloak.logout({
			redirectUri: window.location.origin
		});
		this.isAuthenticated.set(false);
	}

	getToken(): string | undefined {
		return keycloak.token;
	}

	async refreshToken(minValidity = 30): Promise<boolean> {
		try {
			return await keycloak.updateToken(minValidity);
		} catch {
			return false;
		}
	}
}
